import { useEffect, useMemo, useRef, useState } from "react";
import FetchData, {
  CreateEntry,
  GetOne,
  DeleteEntry,
  GetList,
  UpdateEntry,
} from "../../providers/dataProvider";
import Overlay from "react-bootstrap/Overlay";
import { Timeline } from "primereact/timeline";
import Popover from "react-bootstrap/Popover";
import { CheckNull, FormatValueDecimal, calculateNetPrice } from "../../utils/Validate";
import DeleteModal from "../../components/common/DeleteModal";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";
import { QuotationSummary } from "../../components/quotation/QuotationSummary";
import EmptyCart from "../../assets/images/emptyCart.png";
import ErrorMessage from "../../components/common/ErrorMessage";
import { QuotationPrint } from "../../components/quotation/QuotationPrint";
import { ProductQuotationGrid } from "../../components/quotation/ProductQuotationGrid";
import AddForecast from "./AddForecast";
import AddForeCastItem from "./AddForeCastItem";
import BulkForecastModal from "./BulkForecastModal";
import ForecastViewModal from "./ForecastViewModal";
import { useMultiplier } from "../../hooks/useMultiplier";
import { ValidateMessages } from "../../constants/ValidateConstants";
import ConfirmModal from "../common/ConfirmModal";

export const ProductList = ({
  setProductTab,
  ProductTab,
  values,
  setValues,
  setProductListSubmit,
  productListSubmit,
  SaveProductList,
  customerList,
  inquiryList,
  assignedEngineerList,
  projectData,
  deliveryTermsList,
  paymentTermsList,
  setTabValue,
  menuRights,
  currencyList,
  currencyDetail,
  qarCurrencyDetail,
  editQuotation,
  setQuotUserEntry,
  quotUserEntry,
  distributorList,
  showHeader = true
}) => {
  const { userMultiplier } = useMultiplier();
  const [markData, setMarkData] = useState();
  const [markCreateMessage, setMarkCreateMessage] = useState(null);
  const [quotationDt, setQuotationDt] = useState(null);
  const [deleteShow, setDeleteShow] = useState({
    show: false,
    item: "",
    title: "",
    textCode: "",
    text: "",
    loading: false,
  });
  const [createMsg, setCreateMsg] = useState(null);
  const [successShow, setSuccessShow] = useState(false);
  const [quoteCreateMsg, setQuoteCreateMsg] = useState(null);
  const [quoteSuccessShow, setQuoteSuccessShow] = useState(false);
  const [rename, setRename] = useState(null);
  const [markName, setMarkName] = useState(null);
  const [renameMsg, setRenameMsg] = useState(null);
  const [markCounter, setMarkCounter] = useState(1);
  const [salesMargin, setSalesMargin] = useState(null);
  const [quoteUpdateMsg, setQuoteUpdateMessage] = useState(null);
  const [quoteUpdate, setQuoteUpdate] = useState(null);
  const [salesMarginError, setSalesMarginError] = useState(null);
  const [errorShow, setErrorShow] = useState({
    show: false,
    errorMessage: "",
  });
  const [copyMarkConfirm, setCopyMarkConfirm] = useState(false);
  const [currentForecast, setCurrentForecast] = useState(null);
  const [currentItemForecast, setCurrentItemForecast] = useState(null);
  const [currentQuotation, setCurrentQuotation] = useState(null);
  const [openForecast, setOpenForecast] = useState(false);
  const [showForecast, setShowForecast] = useState(false);
  const [openForecastItem, setOpenForecastItem] = useState(false);
  const [showForecastItem, setShowForecastItem] = useState(false);
  const [showForecastView, setShowForecastView] = useState(false);
  const [currentForecastView, setCurrentForecastView] = useState(null);
  const [checkedRows, setCheckedRows] = useState({});
  const [quotationData, setQuotationData] = useState({});
  const [currentMark, setCurrentMark] = useState(null)
  const [renameError, setRenameError] = useState(null);
  const [currentMultiplier, setCurrentMultiplier] = useState([])
  const [multiplierError, setMultiplierError] = useState([])
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const [approval, setApproval] = useState('')
  const [approverSuccess, setApproverSuccess] = useState(false)
  const [sendApproval, setSendApproval] = useState(false)
  const targetRef = useRef(null);
  const marginSavePendingRef = useRef(false);
  const marginSnapshotRef = useRef({});
  const dirtyMarginRowsRef = useRef(new Map());
  const [marginRangeError, setMarginRangeError] = useState([]);
  const [selectedForecastIds, setSelectedForecastIds] = useState({});
  const [showBulkForecast, setShowBulkForecast] = useState(false);


  useEffect(() => {
    if (ProductTab?.status === "updated") {
      GetOne("quotation", { id: values?.id }, setQuotationDt);
    }
  }, [ProductTab?.status]);

  useEffect(() => {
    if (values?.id) {
      GetList("forecast", { quoteId: values?.id }, setQuotationData);
    }
  }, [values?.id]);

  useEffect(() => {
    let submitdata = [];
    let specificationData = [];
    if (markData?.data?.length > 0) {
      markData?.data[0]?.productItems?.map((productitem, productindex) => {
        let params = {
          id: 0,
          quoteProductId: productitem?.quoteProductsId,
          notes: productitem?.notes,
          costingToken: productitem?.costingToken,
          productItemVariants: productitem?.productItemVariants,
        };
        submitdata.push(params);
      });

      markData?.data[0]?.productSpecifications?.map((productSpec, index) => {
        let params = {
          id: 0,
          quoteProductId: productSpec?.quoteProductsId,
          specialCharges: productSpec?.specialCharges,
          specialValue: productSpec?.specialValue,
          specificationId: productSpec?.specificationId,
          specificationValueId: productSpec?.specificationValueId,
        };
        specificationData.push(params);
      });

      if (submitdata?.length > 0) {
        const markName = `mark${markCounter}`;

        let NetPrice =
          markData?.data[0]?.listPrice * markData?.data[0]?.discount;
        let variantsubmitdata = {
          id: 0,
          quotationId: markData?.data[0]?.quotationId,
          markName: "mark" + ((values?.products?.length * 1) + 1),
          productId: markData?.data[0]?.productId,
          quantity: markData?.data[0]?.quantity,
          listPrice: markData?.data[0]?.listPrice,
          margin: markData?.data[0]?.margin,
          salesMargin: 0,
          sellingPrice: 0,
          productItems: submitdata,
          ProductSpecifications: specificationData,
        };

        setMarkCounter(markCounter + 1);
        CreateEntry(
          "productmark",
          variantsubmitdata,
          setMarkCreateMessage,
          "Product submitted successfully",
          "Failed to submit product"
        );
      }
    }
  }, [markData]);

  const [requestData, setRequestData] = useState([])

  useEffect(() => {
    if (markCreateMessage?.message.includes("successfully") === true) {
      GetOne(
        "quotation",
        { id: markData?.data[0]?.quotationId },
        setQuoteUpdate
      );
      setCopyMarkConfirm({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
        status: "",
      });
    }
  }, [markCreateMessage]);

  useEffect(() => {
    if (CheckNull(createMsg?.successData) === "Failure") {
      let errorsmsg = createMsg.message;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
    }
    else if (CheckNull(createMsg?.successData) === "Successful") {
      GetOne("quotation", { id: values?.id }, setQuoteUpdate);
      setDeleteShow({
        show: false,
        item: "",
        title: "",
        textCode: "",
        text: "",
        loading: false,
      });
      setSuccessShow(true);
    }
  }, [createMsg]);

  useEffect(() => {
    if (CheckNull(quoteCreateMsg?.message).includes("Failed")) {
      marginSavePendingRef.current = false;
      setProductListSubmit(true);
      let errorsmsg = quoteCreateMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
    }
    else if (CheckNull(quoteCreateMsg?.status) == 200) {
      const finalizeProductListSave = async () => {
        try {
          if (marginSavePendingRef.current === true) {
            await saveProductMargins();
          }

          GetOne(
            "quotation",
            { id: quoteCreateMsg?.successData?.id || values?.id },
            setQuotationDt
          );

          if (!sendApproval) {
            setQuoteSuccessShow(true);
          }
        } catch (error) {
          setErrorShow({
            show: true,
            errorMessage: error?.message || "Failed to update product margins",
          });
        } finally {
          marginSavePendingRef.current = false;
          setProductListSubmit(false);
        }
      };

      finalizeProductListSave();
    }
  }, [quoteCreateMsg, sendApproval, values?.id]);

  useEffect(() => {
    if (quotationDt?.data) UpdateValues(quotationDt);
  }, [quotationDt]);

  useEffect(() => {
    if (quoteUpdate?.data) UpdateValues(quoteUpdate);
  }, [quoteUpdate]);

  const updateProductMargin = (item) =>
    new Promise((resolve, reject) => {
      UpdateEntry(
        "productmarkmargin",
        {
          id: item?.id,
          margin: Number(item?.margin) || 0,
        },
        (response) => {
          if (response?.status === 200 || response?.status === 204) {
            resolve(response);
          } else {
            reject(new Error(response?.message || "Failed to update product margin"));
          }
        },
        "Product margin updated successfully",
        "Failed to update product margin"
      );
    });

  const updateMultipleProductMargins = (items) =>
    new Promise((resolve, reject) => {
      UpdateEntry(
        "multiplemargin",
        {
          id: values?.id,
          productMargins: items.map((item) => ({
            quoteProductId: item?.id,
            margin: Number(item?.margin) || 0,
          })),
        },
        (response) => {
          if (response?.status === 200 || response?.status === 204) {
            resolve(response);
          } else {
            reject(new Error(response?.message || "Failed to update product margins"));
          }
        },
        "Product margins updated successfully",
        "Failed to update product margins"
      );
    });

  const saveProductMargins = async () => {
    const marginItems = Array.from(dirtyMarginRowsRef.current.entries())
      .map(([id, margin]) => {
        const product = (values?.products || []).find(
          (item) => String(item?.id) === String(id)
        );

        if (!product) return null;

        return {
          ...product,
          margin,
        };
      })
      .filter(Boolean);

    if (marginItems.length === 0) {
      return;
    }

    if (marginItems.length === 1) {
      await updateProductMargin(marginItems[0]);
    } else {
      await updateMultipleProductMargins(marginItems);
    }

    dirtyMarginRowsRef.current.clear();
  };

  const UpdateValues = (quoteData) => {
    const productsarr = [];
    const marginSnapshot = {};

    quoteData?.data?.products?.map((element, index) => {
      const currMul = values?.products?.find(prodItem => prodItem?.id === element?.id)

      //  actuatorCost preserve
      const existingActuatorCost = currMul?.actuatorCost ||
        currMul?.productItems?.[0]?.productItemVariants
          ?.find(v => v?.variantId === 50)?.variantValue || 0;
      const existingProductItems = currMul?.productItems || element?.productItems;

      const isDirtyMargin = dirtyMarginRowsRef.current.has(element?.id);
      const resolvedMargin = isDirtyMargin
        ? (currMul?.margin ?? element?.margin)
        : (element?.margin ?? currMul?.margin);

      let temp = {
        groupId: element?.groupId,
        id: element?.id,
        listPrice: element?.listPrice,
        markName: element?.markName,
        margin: resolvedMargin,
        productId: element?.productId,
        productName: element?.productName,
        productSubGroupId: element?.productSubGroupId,
        quantity: element?.quoteQuantity,
        quoteQuantity: element?.quoteQuantity,
        quotationId: element?.quotationId,
        salesMargin: 0,
        sellingPrice: 0,
        totalDdp: element?.totalDdp,
        materialCost: element?.materialCost,
        labourCost: element?.labourCost,
        approvalStatus: element?.approvalStatus,
        currentUserApprovalScope: element?.currentUserApprovalScope,
        isActionableForCurrentUser: element?.isActionableForCurrentUser,
        actuatorCost: existingActuatorCost,
        powderArea: currMul?.powderArea ?? element?.powderArea ?? existingProductItems?.[0]?.powderArea,
        productItems: existingProductItems,
        productSpecifications: currMul?.productSpecifications || element?.productSpecifications,
      };
      productsarr.push(temp);
      marginSnapshot[element?.id] = Number(temp?.margin ?? 0);
    });

    marginSnapshotRef.current = marginSnapshot;
    dirtyMarginRowsRef.current.clear();

    if (quoteData?.data) setValues({ ...values, products: productsarr });
  };

  useEffect(() => {
    const productIds = new Set((values?.products || []).map((item) => String(item?.id)));
    setSelectedForecastIds((prev) => {
      const next = {};
      Object.entries(prev || {}).forEach(([id, isSelected]) => {
        if (isSelected && productIds.has(String(id))) {
          next[id] = true;
        }
      });
      return next;
    });
  }, [values?.products]);

  const forecastedItemIds = useMemo(
    () =>
      new Set(
        (quotationData?.data || [])
          .filter((item) => Number(item?.forecastedAmount) > 0)
          .map((item) => item?.quoteProductId)
          .filter((id) => id !== undefined && id !== null)
          .map((id) => String(id))
      ),
    [quotationData?.data]
  );

  const forecastSummaryMap = useMemo(
    () =>
      new Map(
        (quotationData?.data || []).map((item) => [
          String(item?.quoteProductId),
          item,
        ])
      ),
    [quotationData?.data]
  );
  const isForecastedItem = (item) =>
    forecastedItemIds.has(String(item?.id));

  const selectedForecastItems = useMemo(
    () =>
      (values?.products || []).filter(
        (item) => selectedForecastIds?.[item?.id] && !isForecastedItem(item)
      ),
    [values?.products, selectedForecastIds, forecastedItemIds]
  );
  const hasForecastedItems = forecastedItemIds.size > 0;
  const defaultForecastItem = useMemo(
    () => (values?.products || []).find((item) => isForecastedItem(item)) || null,
    [values?.products, forecastedItemIds]
  );

  const selectableForecastItems = (values?.products || []).filter(
    (item) => !isForecastedItem(item)
  );
  const isAllSelectableForecastedSelected =
    selectableForecastItems.length > 0 &&
    selectableForecastItems.every((item) => selectedForecastIds?.[item?.id]);

  const toggleForecastSelection = (item) => {
    if (!item?.id || isForecastedItem(item)) return;

    setSelectedForecastIds((prev) => ({
      ...prev,
      [item.id]: !prev?.[item.id],
    }));
  };

  const toggleAllForecastSelection = () => {
    if (selectableForecastItems.length === 0) return;

    const shouldSelectAll = !isAllSelectableForecastedSelected;
    setSelectedForecastIds((prev) => {
      const next = { ...prev };

      selectableForecastItems.forEach((item) => {
        next[item.id] = shouldSelectAll;
      });

      return next;
    });
  };

  const openBulkForecast = () => {
    if (selectedForecastItems.length === 0) return;

    GetList("forecast", { quoteId: values?.id }, setQuotationData);
    setShowBulkForecast(true);
  };

  const handleBulkForecastSaved = (savedItems = []) => {
    const firstItem = savedItems?.[0];

    setSelectedForecastIds({});
    setShowBulkForecast(false);
    GetList("forecast", { quoteId: values?.id }, setQuotationData);

    if (firstItem) {
      OpenAddForecast(firstItem);
    }
  };

  useEffect(() => {
    if (renameMsg?.message.includes("successfully") === true) {
      GetOne("quotation", { id: values?.id }, setQuotationDt);
      setRename(null);
    }
  }, [renameMsg]);

  useEffect(() => {
    setSelectedForecastIds((prev) => {
      const next = {};
      Object.entries(prev || {}).forEach(([id, isSelected]) => {
        if (isSelected && !forecastedItemIds.has(String(id))) {
          next[id] = true;
        }
      });

      return next;
    });
  }, [forecastedItemIds, values?.products]);

  const AddDuplicate = (item) => {
    setSalesMargin(item?.salesMargin);
    GetList("productmark", { id: item?.id }, setMarkData);
  };

  const HandleCopyMark = (item) => {
    setCopyMarkConfirm({
      show: true,
      item: item,
      title: "You want to copy this Mark?",
      textCode: "Mark Name",
      text: item?.markName,
      loading: false,
      status: "copymark",
    });
  };

  const HandleCancelProcess = () => {
    setCopyMarkConfirm({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
      status: "",
    });
  };

  const HandleConfirmProcess = (item) => {
    setCopyMarkConfirm({
      ...copyMarkConfirm,
      loading: true,
    });

    if (copyMarkConfirm?.status === "copymark") AddDuplicate(item)
  };

  const EditMark = (item) => {
    if (multiplierError?.length <= 0) {
      setProductTab({
        tab: "ProductQuotation",
        id: { productGroupId: item?.groupId, item, id: item?.productSubGroupId },
        status: "editmark",
      });
    }
  };

  const ProductRename = (item) => {
    setRename(item);
  };

  const DeleteMark = (item) => {
    setDeleteShow({
      show: true,
      item: item,
      title: "You want delete this Mark?",
      textCode: "Mark Name",
      text: item?.markName,
      loading: false,
    });
  };

  const HandleCancelDelete = () => {
    setDeleteShow({
      show: false,
      item: "",
      title: "",
      textCode: "",
      text: "",
      loading: false,
    });
  };

  const HandleConfirmDelete = (item) => {
    setDeleteShow({
      ...deleteShow,
      loading: true,
    });
    DeleteEntry(
      "productmarkdelete",
      item,
      setCreateMsg,
      "Mark deleted successfully",
      "Failed to delete Mark"
    );
  };

  const SuccessDoneClick = () => {
    setSuccessShow(false);
    setQuoteSuccessShow(false);
    setApproverSuccess(false)
    setRequestSuccess(false)
    setCreateMsg(null);
    setQuoteCreateMsg(null);
  };

  const updateMarkName = () => {
    if (rename?.markName) {
      setRenameError(null);
      UpdateEntry(
        "renamemarkname",
        { quoteProductId: rename?.id, markName: rename?.markName },
        setRenameMsg,
        "Mark Name updated successfully",
        "Failed to update markName"
      );
    }
    else {
      setRenameError(ValidateMessages?.REQUIRED("Name"))
    }
  };

  const HandleKeyDown = (event) => {
    if (event.key === "Enter") {
      updateMarkName();
    }
  };

  const HandleOnBlur = () => {
    updateMarkName();
  };

  const CalculateSellingPrice = (e, item) => {
    const value = e.target.value;

    if (value !== "" && value !== "-") {
      const numValue = Number(value);
      const isOutOfRange = isNaN(numValue) || numValue < -100 || numValue > 99.99;

      if (isOutOfRange) {
        setMarginRangeError((prev) => {
          const filtered = prev.filter((err) => err?.id !== item?.id);
          return [...filtered, { id: item?.id, message: "Valid margin -100 to 99.99." }];
        });
        return;
      }
    }

    setMarginRangeError((prev) => prev.filter((err) => err?.id !== item?.id));

    const normalizedMargin = value === "" || value === "-" ? "" : Number(value);
    setValues((prevValues) => {
      const productArray = [...(prevValues?.products || [])];
      const index = productArray.findIndex((i) => String(i.id) === String(item.id));

      if (index === -1) {
        return prevValues;
      }

      const nextProduct = {
        ...productArray[index],
        margin: value,
      };

      nextProduct.totalDdp = calculateNetPrice(nextProduct);
      productArray[index] = nextProduct;

      return { ...prevValues, products: productArray };
    });

    if (item?.id) {
      const originalMargin = Number(marginSnapshotRef.current?.[item.id] ?? 0);
      const currentMargin = Number(normalizedMargin || 0);

      if (currentMargin !== originalMargin) {
        dirtyMarginRowsRef.current.set(item.id, currentMargin);
      } else {
        dirtyMarginRowsRef.current.delete(item.id);
      }
    }
  };

  const HandleFocusOutMultiplier = (e, item) => {
    const productDiscount = userMultiplier?.mlpPermissions?.find(
      (userMul) => userMul?.productGroupId === item?.groupId
    )?.maximumDiscount;

    if (item?.margin > productDiscount) {
      setApproval(item?.quotationId)
    }
    else {
      setApproval('')
    }
  };

  useEffect(() => {
    if (values?.products?.length) {
      setCurrentMultiplier(values.products.map(({ id, margin }) => ({ id, margin })));
    }
  }, [values?.id]);
  useEffect(() => {
    if (productListSubmit === true) {
      marginSavePendingRef.current = true;
      if (values?.id !== "") {
        const valuesCopy = values;
        valuesCopy.modifiedBy = localStorage.getItem("authidentity");
        UpdateEntry(
          "quotation",
          valuesCopy,
          setQuoteCreateMsg,
          "Quotation updated successfully",
          "Failed to update quotation"
        );
      } else {
        CreateEntry(
          "quotation",
          values,
          setQuoteCreateMsg,
          "Quotation created successfully",
          "Failed to create quotation"
        );
      }
    }
  }, [productListSubmit]);

  const ErrorDoneClick = () => {
    setErrorShow({
      show: false,
      errorMessage: "",
    });
    setCreateMsg(null);

  };

  const navigateToJobInHand = () => {
    setTabValue("General")
  }

  const OpenAddForecast = (item) => {
    GetList("forecast", { quoteId: values?.id }, setQuotationData);
    setCurrentMark(item);
    setOpenForecast(true);
    setShowForecast(true);
  };

  const OpenForecastView = (item) => {
    const forecastSummary = forecastSummaryMap.get(String(item?.id));
    if (!forecastSummary) return;

    setCurrentForecastView({
      ...forecastSummary,
      quotationId: item?.quotationId || values?.id,
      quoteProductId: item?.id,
      quotedAmount: calculateNetPrice(item),
      quantity: item?.quantity,
      productGroupName: item?.productGroupName || item?.groupName,
      productName: item?.productName,
    });
    setShowForecastView(true);
  };

  const handleForecastAction = (item) => {
    if (!item?.id) return;

    if (selectedForecastIds?.[item?.id] && !isForecastedItem(item)) {
      openBulkForecast();
      return;
    }

    if (isForecastedItem(item)) {
      OpenForecastView(item);
      return;
    }

  };

  const OpenAddForecastItem = (item) => {
    const firstProductItem = item?.productItems?.[0] || {};
    const quoteProductItemId =
      firstProductItem?.quoteProductItemId ||
      firstProductItem?.id ||
      firstProductItem?.quoteProductsId ||
      item?.productItems?.find((productItem) => productItem?.quoteProductItemId)?.quoteProductItemId ||
      item?.id;

    setCurrentItemForecast({
      ...item,
      quoteProductId: item?.id,
      quoteProductItemId,
      productGroupId: item?.groupId,
      productGroupName: item?.productGroupName || item?.groupName,
      productName: item?.productName,
      quotationId: item?.quotationId || values?.id,
    });
    setCheckedRows({});
    setOpenForecastItem(true);
    setShowForecastItem((prev) => !prev);
  };

  useEffect(() => {
    const currentFC = quotationData?.data?.find(
      item => item?.quoteProductId === currentMark?.id
    );
    if (currentFC) {
      setCurrentForecast({
        ...currentFC,
        quotedAmount: calculateNetPrice(currentMark)
      });
    }
  }, [quotationData]);

  const [showPopover, setShowPopover] = useState(false);
  const [target, setTarget] = useState(null);

  const [showReject, setShowReject] = useState(false);
  const [rejectTarget, setRejectTarget] = useState(null);

  const [showApproved, setShowApproved] = useState(false);
  const [approvedTarget, setApprovedTarget] = useState(null);

  const [showPending, setShowPending] = useState(false);
  const [pendingTarget, setPendingTarget] = useState(null);

  const [showRejected, setShowRejected] = useState(false);
  const [rejectedTarget, setRejectedTarget] = useState(null);

  const [activeRowId, setActiveRowId] = useState(null);
  const [approverMsg, setApproverMsg] = useState([])
  const [approveRemarks, setApproveRemarks] = useState("");
  const [rejectRemarks, setRejectRemarks] = useState("");
  const [quoteId, setQuoteId] = useState('')

  const getApprovalQuoteProductIds = () => {
    if (activeRowId !== null && activeRowId !== undefined) {
      return [Number(activeRowId)];
    }

    return (values?.products || [])
      .map((item) => Number(item?.id))
      .filter((id) => !Number.isNaN(id));
  };

  const getApprovalDecision = (quoteProductId, isApproved) => {
    const selectedProduct = (values?.products || []).find(
      (item) => String(item?.id) === String(quoteProductId)
    );

    const marginValue = Number(selectedProduct?.margin || 0);

    return {
      quoteProductId: Number(quoteProductId),
      approvedDiscountPercentage: isApproved && marginValue < 0
        ? Math.abs(marginValue)
        : 0,
    };
  };

  const HandleRequest = async () => {
    setSendApproval(true)
    try {
      if (dirtyMarginRowsRef.current.size > 0) {
        await saveProductMargins();
      }

      let data = {
        remarks: "Approval Requested"
      };

      let response;

      if (values?.id) {
        response = await UpdateEntry(
          "quotation",
          {
            ...values,
            modifiedBy: localStorage.getItem("authidentity")
          },
          setQuoteCreateMsg,
          "Quotation updated successfully",
          "Failed to update quotation"
        );
      } else {
        response = await CreateEntry(
          "quotation",
          values,
          setQuoteCreateMsg,
          "Quotation created successfully",
          "Failed to create quotation"
        );
      }

      const quotationId =
        values?.id ||
        response?.id ||
        response?.data?.id;

      await CreateEntry(
        "quotationRequest",
        {
          id: quotationId,
          remarks: data.remarks
        },
        setRequestData,
        "Request submitted successfully",
        "Failed to submit request"
      );

    } catch (error) {
      console.error("Error in flow:", error);
    }
  };

  const HandleApprove = () => {
    const quoteProductIds = getApprovalQuoteProductIds();
    const data = {
      isApproved: true,
      remarks: approveRemarks,
      quoteProductIds,
      productDecisions: quoteProductIds.length > 0
        ? quoteProductIds.map((quoteProductId) =>
          getApprovalDecision(quoteProductId, true)
        )
        : [],
    };

    CreateEntry(
      "quotationApprovalRequest",
      { ...data, id: quoteId },
      setApproverMsg,
      "Approved successfully",
      "Failed to approved"
    );
    setApproveRemarks("")
    setShowPopover(false);
  }

  const HandleReject = () => {
    const quoteProductIds = getApprovalQuoteProductIds();
    const data = {
      isApproved: false,
      remarks: rejectRemarks,
      quoteProductIds,
      productDecisions: quoteProductIds.length > 0
        ? quoteProductIds.map((quoteProductId) =>
          getApprovalDecision(quoteProductId, false)
        )
        : [],
    };

    CreateEntry(
      "quotationApprovalRequest",
      { ...data, id: quoteId },
      setApproverMsg,
      "Rejected successfully",
      "Failed to reject"
    );
    setRejectRemarks('')
    setShowPopover(false);
  }

  useEffect(() => {
    if (CheckNull(approverMsg?.message).includes("Failed")) {
      let errorsmsg = approverMsg.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
    }
    else if (CheckNull(approverMsg?.status) == 200) {
      setApproverSuccess(true);
      GetList("quotationPendingRequest", { id: values?.id }, setQuotePending);
      GetOne("quotation", { id: values?.id }, setQuotationDt);
      window.dispatchEvent(new Event("approvalStatusChanged"));
    }
  }, [approverMsg]);

  const [requestSuccess, setRequestSuccess] = useState(false)
  useEffect(() => {
    if (CheckNull(requestData?.message).includes("Failed")) {
      let errorsmsg = requestData.successData;
      setErrorShow({
        show: true,
        errorMessage: errorsmsg,
      });
    }
    else if (CheckNull(requestData?.status) == 200) {
      setRequestSuccess(true);
      GetList("quotationPendingRequest", { id: values?.id }, setQuotePending);
      GetOne("quotation", { id: values?.id }, setQuotationDt);
    }
  }, [requestData]);

  const [quotePending, setQuotePending] = useState([])

  useEffect(() => {
    if (values?.id) {
      GetList("quotationPendingRequest", { id: values?.id }, setQuotePending)
    }
  }, [values?.id])

  const formatDateTime = (date) => {
    if (!date) return "";

    const utcDate = new Date(date + "Z");

    return utcDate.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const selectedLineApproved = values?.products?.find(
    (line) =>
      line?.id === activeRowId &&
      (line?.approvalStatus === "Approved" ||
        line?.approvalStatus === "RequiresResubmission")
  );

  const selectedLineCancelled = quotePending?.data?.lines?.find(
    (line) =>
      line?.quoteProductId === activeRowId &&
      (line?.status === "Cancelled")
  );

  const selectedLine = quotePending?.data?.lines?.find(
    (line) =>
      line?.quoteProductId === activeRowId &&
      (line?.status === "Approved" ||
        line?.status === "RequiresResubmission")
  );
  const selectedLinePending = quotePending?.data?.lines?.find(
    (line) =>
      line?.quoteProductId === activeRowId &&
      line?.status === "Pending"
  );

  const selectedStep = quotePending?.data?.steps?.find(
    (step) => step?.approvalRank === selectedLine?.requiredApproverRank
  );

  const selectedApprover = selectedStep?.assignees?.find(
    (a) => a?.identityId === selectedLine?.decisionByIdentityId
  );

  const isApprovedLine =
    selectedLineApproved &&
    ["Approved", "RequiresResubmission"].includes(selectedLineApproved?.approvalStatus);

  const filteredSteps = quotePending?.data?.steps?.filter(
    (step) =>
      step?.decisionStatus === "Pending" &&
      step?.maximumRequestedDiscountPercentage ===
      selectedLinePending?.requestedDiscountPercentage
  );

  const selectedRejectedLine = quotePending?.data?.lines?.find(
    (line) =>
      line?.quoteProductId === activeRowId &&
      line?.status === "Rejected"
  );

  const selectedRejectedStep = quotePending?.data?.steps?.find(
    (step) => step?.approvalRank === selectedRejectedLine?.requiredApproverRank
  );

  const selectedRejectedApprover = selectedRejectedStep?.assignees?.find(
    (a) => a?.identityId === selectedRejectedLine?.decisionByIdentityId
  );

  const isRejectedLine =
    selectedRejectedLine && selectedRejectedLine?.status === "Rejected";

  const allCompleted = quotePending?.data?.lines?.every(
    (line) => line?.status === "Approved" || line?.status === "Rejected"
  );

  const isApprovalRequired = values?.products?.some((item) => {
    const productDiscount = Number(
      userMultiplier?.mlpPermissions?.find(
        (userMul) => userMul?.productGroupId === item?.groupId
      )?.maximumDiscount || 0
    );

    const approvalLine = quotePending?.data?.lines?.find(
      (line) => line?.quoteProductId === item?.id
    );

    const approvedDiscount = Number(
      approvalLine?.requestedDiscountPercentage || 0
    );

    const margin = Number(item?.margin || 0);

    if (allCompleted) {
      return (
        margin < 0 &&
        Math.abs(margin) > productDiscount &&
        Math.abs(margin) !== Math.abs(approvedDiscount)
      );
    }

    return (
      margin < 0 &&
      Math.abs(margin) > productDiscount
    );
  });

  const isApprovalInProgress =
    values?.products?.some(
      item =>
        item?.currentUserApprovalScope === "Actionable" &&
        item?.isActionableForCurrentUser
    ) ||
    (quotePending?.data?.requesterIdentityId === userProfile?.identityId &&
      quotePending?.data?.status === "Pending");

  return (
    <>
      <div className="row pt-1 product-configurations-row mt-2">
        {showHeader && (
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card mb-2">
              <div className="card-body">
                <div className="row print-area-row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex align-items-center">
                      <h6 onClick={navigateToJobInHand}>
                        <i class="fas fa-angle-left"></i>
                      </h6>
                      <h1>Products</h1>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto">
                    <div className="d-flex justify-content-end">
                      {isApprovalRequired || isApprovalInProgress ? "" : values?.products?.length > 0 && menuRights?.canPrint === true && <QuotationPrint distributorList={distributorList} values={values} currencyDetail={currencyDetail} />}
                      {/* {values?.products?.length > 0 && (
                          values?.products?.some(
                            item =>
                              item?.currentUserApprovalScope === "Approved" &&
                              !item?.isActionableForCurrentUser
                          ) || quotePending?.data?.requesterIdentityId !== userProfile?.identityId && quotePending?.data?.status === "Approved")
                         && menuRights?.canPrint === true && <QuotationPrint distributorList={distributorList} values={values} currencyDetail={currencyDetail} />} */}
                      <div className="text-right d-flex align-items-center gap-2">

                        {/* {values?.products?.length > 0 && multiplierError?.length <= 0 && (<button
                        className="btn save-btn"
                        type="button"
                        onClick={SaveProductList}
                      >
                        Save
                      </button>)} */}
                        {
                          isApprovalInProgress ? (
                            <span className="approval-text">
                              <i className="fas fa-exclamation-circle approval-icon"></i>
                              Quote under approval
                            </span>
                          ) : isApprovalRequired ? (
                            <button
                              className="btn approval-request-btn"
                              type="button"
                              onClick={HandleRequest}
                            >
                              Request Approval
                            </button>
                          ) : (
                            values?.products?.length > 0 &&
                            multiplierError?.length <= 0 && (
                              <button
                                className="btn save-btn"
                                type="button"
                                onClick={SaveProductList}
                              >
                                Save
                              </button>
                            )
                          )
                        }
                        {selectedForecastItems.length > 0 ? (
                          <button
                            className="btn forecast-btn"
                            type="button"
                            onClick={openBulkForecast}
                          >
                            New Forecast
                          </button>
                        ) : hasForecastedItems ? (
                          <button
                            className="btn forecast-btn"
                            type="button"
                            onClick={() => defaultForecastItem && OpenForecastView(defaultForecastItem)}
                          >
                            Forecast
                          </button>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {!showHeader && (
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="quote-product-actionbar">
              <div>
                <span>Products</span>
                <strong>{values?.products?.length || 0} mark{values?.products?.length === 1 ? "" : "s"}</strong>
              </div>
              <div className="d-flex">
                {currencyDetail?.shortCode && (
                  <div className="quote-product-actionbar-currency mr-2">
                    <span>Currency</span> :
                    <strong>{currencyDetail.shortCode}</strong>
                  </div>
                )}
                <div className="quote-product-actionbar-actions">
                  {multiplierError?.length <= 0 && (
                    <button
                      className="btn quote-product-add-btn"
                      type="button"
                      onClick={() => {
                        setProductTab({ tab: "MainCategory", id: 0 });
                      }}
                    >
                      <i className="fas fa-plus"></i>
                      <span>Add Mark</span>
                    </button>
                  )}

                  {isApprovalInProgress ? (
                    <span className="approval-text">
                      <i className="fas fa-exclamation-circle approval-icon"></i>
                      Quote under approval
                    </span>
                  ) : isApprovalRequired ? (
                    <button
                      className="btn approval-request-btn"
                      type="button"
                      onClick={HandleRequest}
                    >
                      Request Approval
                    </button>
                  ) : (
                    values?.products?.length > 0 &&
                    multiplierError?.length <= 0 && (
                      <button
                        className="btn save-btn"
                        type="button"
                        onClick={SaveProductList}
                      >
                        Save
                      </button>
                    )
                  )}
                  {selectedForecastItems.length > 0 ? (
                    <button
                      className="btn forecast-btn"
                      type="button"
                      onClick={openBulkForecast}
                    >
                      New Forecast
                    </button>
                  ) : hasForecastedItems ? (
                    <button
                      className="btn forecast-btn"
                      type="button"
                      onClick={() => defaultForecastItem && OpenForecastView(defaultForecastItem)}
                    >
                      Forecast
                    </button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="row quotation-summary-row">
            <div className="col-xxl-10 col-xl-10 col-lg-9 col-md-12 col-sm-12 col-xs-12 center-card">
              <div className="card">
                <div className="card-body pt-0 pr-0 pl-0">
                  {values?.products?.length > 0 ? (
                    <ProductQuotationGrid
                      currencyDetail={currencyDetail}
                      multiplierError={multiplierError}
                      marginRangeError={marginRangeError}
                      quotePending={quotePending}
                      rename={rename}
                      renameError={renameError}
                      selectedLineCancelled={selectedLineCancelled}
                      userMultiplier={userMultiplier}
                      userProfile={userProfile}
                      values={values}
                      selectedForecastIds={selectedForecastIds}
                      allSelectableForecastSelected={isAllSelectableForecastedSelected}
                      selectableForecastCount={selectableForecastItems.length}
                      isForecastedItem={isForecastedItem}
                      onActionableApproval={(e, item) => {
                        setTarget(e.currentTarget);
                        setActiveRowId(item.id);
                        setQuoteId(item?.quotationId);
                        setShowReject(false);
                        setShowPopover((prev) => activeRowId === item.id ? !prev : true);
                      }}
                      onApprovalIndicator={(status, e, item) => {
                        setActiveRowId(item.id);
                        setQuoteId(item?.quotationId);
                        if (status === "approved" || status === "requiresResubmission") {
                          setApprovedTarget(e.currentTarget);
                          setShowPending(false);
                          setShowRejected(false);
                          setShowApproved((prev) => activeRowId === item.id ? !prev : true);
                        }
                        if (status === "pending") {
                          setPendingTarget(e.currentTarget);
                          setShowApproved(false);
                          setShowRejected(false);
                          setShowPending((prev) => activeRowId === item.id ? !prev : true);
                        }
                        if (status === "rejected") {
                          setRejectedTarget(e.currentTarget);
                          setShowApproved(false);
                          setShowPending(false);
                          setShowRejected((prev) => activeRowId === item.id ? !prev : true);
                        }
                      }}
                      onCopy={HandleCopyMark}
                      onDelete={DeleteMark}
                      onEdit={EditMark}
                      onForecast={OpenAddForecast}
                      onForecastSelect={toggleForecastSelection}
                      onForecastSelectAll={toggleAllForecastSelection}
                      onItemForecast={OpenAddForecastItem}
                      onMarginBlur={HandleFocusOutMultiplier}
                      onMarginChange={CalculateSellingPrice}
                      onRename={ProductRename}
                      onRenameBlur={HandleOnBlur}
                      onRenameChange={setRename}
                      onRenameKeyDown={HandleKeyDown}
                    />
                  ) : (
                    <div className="no-product-data quote-product-empty-state">
                      <div className="quote-product-empty-visual" aria-hidden="true">
                        <img src={EmptyCart} alt="" />
                      </div>
                      <div className="quote-product-empty-copy">
                        <strong>No marks added yet</strong>
                        <span>Add the first product mark to start pricing this quote.</span>
                      </div>
                      <button
                        type="button"
                        className="btn quote-product-empty-action"
                        onClick={() => {
                          setProductTab({ tab: "MainCategory", id: 0 });
                        }}
                      >
                        <i className="fas fa-plus"></i>
                        Add Mark
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xxl-2 col-xl-2 col-lg-3 col-md-12 col-sm-12 col-xs-12 right-side-card">
              <QuotationSummary
                values={values}
                setValues={setValues}
                FormatValueDecimal={FormatValueDecimal}
                currencyList={currencyList}
                currencyDetail={currencyDetail}
                qarCurrencyDetail={qarCurrencyDetail}
                editQuotation={editQuotation}
                setQuotUserEntry={setQuotUserEntry}
                quotUserEntry={quotUserEntry}
              />
            </div>
          </div>
        </div>
      </div>

      <Overlay
        show={showPopover}
        target={target}
        placement="bottom"
        rootClose={true}
        onHide={() => setShowPopover(false)}
      >
        <Popover className="approve-popover"
        >
          <Popover.Body>
            <h3>Approver Remarks</h3>
            <hr />
            <textarea
              rows={4}
              className="form-control mb-2"
              placeholder="Enter your remarks here"
              value={approveRemarks}
              onChange={(e) => setApproveRemarks(e.target.value)}
            />

            <div className="mt-3 d-flex">
              <button className="btn btn-sm btn-success w-100 mr-2" onClick={HandleApprove}>
                Approve
              </button>
              <button className="btn btn-sm btn-danger w-100" onClick={HandleReject}>
                Reject
              </button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
      <Overlay show={showReject} target={rejectTarget} placement="bottom">
        <Popover className="approve-popover">
          <Popover.Body>
            <h3>Rejecter Remarks</h3>
            <hr />
            <textarea
              rows={4}
              className="form-control mb-2"
              placeholder="Enter your remarks here"
              value={rejectRemarks}
              onChange={(e) => setRejectRemarks(e.target.value)}
            />

            <div className="mt-3">
              <button className="btn btn-sm btn-danger w-100" onClick={HandleReject}>
                Reject
              </button>
            </div>
          </Popover.Body>
        </Popover>
      </Overlay>
      {/* Approved */}
      <Overlay show={showApproved} target={approvedTarget} placement="bottom">
        <Popover
          className="approved"
          onMouseEnter={() => setShowApproved(true)}
          onMouseLeave={() => setShowApproved(false)}
        >
          <Popover.Body>

            {isApprovedLine ? (
              <div className="approved-wrapper">

                {/* HEADER */}
                <div className="d-flex align-items-center gap-2">
                  <i className="fas fa-check mr-2"></i>
                  <h6>
                    {"Approved"} - {selectedLine?.markName}
                  </h6>
                </div>

                <hr />

                <ol className="c-timeline m-0">

                  {/* USER */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-user mr-2"></i>
                      <p className="c-timeline__desc">
                        {selectedApprover?.fullName || "-"}
                      </p>
                    </div>
                  </li>

                  {/* ROLE */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-briefcase mr-2"></i>
                      <p className="c-timeline__desc">
                        {selectedStep?.approverRoleName || "-"}
                      </p>
                    </div>
                  </li>

                  {/* DATE */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-calendar mr-2"></i>
                      <p className="c-timeline__desc">
                        {formatDateTime(selectedLine?.decisionAt)}
                      </p>
                    </div>
                  </li>

                  {/* NOTE */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-clipboard mr-2"></i>
                      <p className="c-timeline__desc">
                        Approved with standard discount - {selectedLine?.requestedMaximumDiscount}
                      </p>
                    </div>
                  </li>

                </ol>

              </div>
            ) : (
              <p>No approval data</p>
            )}

          </Popover.Body>
        </Popover>
      </Overlay>
      {/* Pending */}
      {quotePending?.data?.status === "Pending" && (
        <Overlay show={showPending} target={pendingTarget} placement="bottom">
          <Popover
            className="pending"
            onMouseEnter={() => setShowPending(true)}
            onMouseLeave={() => setShowPending(false)}
          >
            <Popover.Body>

              {filteredSteps?.length > 0 && (
                filteredSteps.map((step, index) => (
                  <div className="approved-wrapper" key={index}>

                    <div className="d-flex align-items-center gap-2">
                      <i className="fas fa-check mr-2"></i>
                      <h6>{step?.decisionStatus}</h6>
                    </div>

                    <hr />
                    {step?.assignees?.map((assignee, i) => (
                      <ol className="c-timeline m-0" key={i}>

                        {/* USER */}
                        <li className="c-timeline__item">
                          <div className="c-timeline__content d-flex align-items-center">
                            <i className="fas fa-user mr-2"></i>
                            <p className="c-timeline__desc">{assignee?.fullName}</p>
                          </div>
                        </li>

                        {/* ROLE */}
                        <li className="c-timeline__item">
                          <div className="c-timeline__content d-flex align-items-center">
                            <i className="fas fa-briefcase mr-2"></i>
                            <p className="c-timeline__desc">{step?.approverRoleName}</p>
                          </div>
                        </li>

                        {/* DATE */}
                        <li className="c-timeline__item">
                          <div className="c-timeline__content d-flex align-items-center">
                            <i className="fas fa-calendar mr-2"></i>
                            <p className="c-timeline__desc">
                              {formatDateTime(quotePending?.data?.requestedAt)}
                            </p>
                          </div>
                        </li>

                      </ol>
                    ))}

                  </div>
                ))
              )}
            </Popover.Body>
          </Popover>
        </Overlay>
      )}
      {/* Rejected */}
      <Overlay show={showRejected} target={rejectedTarget} placement="bottom">
        <Popover
          className="rejected"
          onMouseEnter={() => setShowRejected(true)}
          onMouseLeave={() => setShowRejected(false)}
        >
          <Popover.Body>

            {isRejectedLine ? (
              <div className="rejected-wrapper">

                {/* HEADER */}
                <div className="d-flex align-items-center gap-2">
                  <i className="fas fa-times mr-2 text-danger"></i>
                  <h6>
                    Rejected - {selectedRejectedLine?.markName}
                  </h6>
                </div>

                <hr />

                <ol className="c-timeline m-0">

                  {/* USER */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-user mr-2"></i>
                      <p className="c-timeline__desc">
                        {selectedRejectedApprover?.fullName || "-"}
                      </p>
                    </div>
                  </li>

                  {/* ROLE */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-briefcase mr-2"></i>
                      <p className="c-timeline__desc">
                        {selectedRejectedStep?.approverRoleName || "-"}
                      </p>
                    </div>
                  </li>

                  {/* DATE */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-calendar mr-2"></i>
                      <p className="c-timeline__desc">
                        {formatDateTime(selectedRejectedLine?.decisionAt)}
                      </p>
                    </div>
                  </li>

                  {/* REMARK */}
                  <li className="c-timeline__item">
                    <div className="c-timeline__content d-flex align-items-center">
                      <i className="fas fa-clipboard mr-2"></i>
                      <p className="c-timeline__desc">
                        {selectedRejectedLine?.decisionRemarks || "Rejected"}
                      </p>
                    </div>
                  </li>

                </ol>

              </div>
            ) : (
              <p>No rejection data</p>
            )}

          </Popover.Body>
        </Popover>
      </Overlay>
      <AddForecast showForecast={showForecast}
        setOpenForecast={setOpenForecast}
        openForecast={openForecast}
        currentForecast={currentForecast}
        currentQuotation={{ id: values?.id, row: values }}
        setQuotationData={setQuotationData}
        currencyDetail={currencyDetail}
      />
      <AddForeCastItem
        showForecast={showForecastItem}
        setOpenForecast={setOpenForecastItem}
        openForecast={openForecastItem}
        currentForecast={currentItemForecast}
        currentQuotation={{ id: values?.id, row: values }}
        setQuotationData={setQuotationData}
        currencyDetail={currencyDetail}
        setCheckedRows={setCheckedRows}
        checkedRows={checkedRows}
      />
      <ForecastViewModal
        show={showForecastView}
        onHide={() => {
          setShowForecastView(false);
          setCurrentForecastView(null);
        }}
        currentForecast={currentForecastView}
        currentQuotation={{ id: values?.id, row: values }}
        forecastData={quotationData}
        currencyDetail={currencyDetail}
        setQuotationData={setQuotationData}
        forecastedItemIds={forecastedItemIds}
      />
      <BulkForecastModal
        show={showBulkForecast}
        onHide={() => setShowBulkForecast(false)}
        items={selectedForecastItems}
        quoteId={values?.id}
        currencyDetail={currencyDetail}
        conversionRate={values?.conversionRate}
        existingForecasts={quotationData?.data || []}
        onSaved={handleBulkForecastSaved}
      />
      <DeleteModal
        deleteShow={deleteShow}
        handleCancelDelete={HandleCancelDelete}
        handleConfirmDelete={HandleConfirmDelete}
      />
      <ConfirmModal
        confirmShow={copyMarkConfirm}
        HandleConfirmCancel={HandleCancelProcess}
        HandleConfirmOk={HandleConfirmProcess}
      />
      <SaveSuccessModel
        show={requestSuccess}
        createMsg={requestData}
        setShow={setRequestSuccess}
        SuccessDoneClick={SuccessDoneClick}
      />
      <SaveSuccessModel
        show={approverSuccess}
        createMsg={approverMsg}
        setShow={setApproverSuccess}
        SuccessDoneClick={SuccessDoneClick}
      />
      <SaveSuccessModel
        show={successShow}
        createMsg={createMsg}
        setShow={setSuccessShow}
        SuccessDoneClick={SuccessDoneClick}
      />
      <SaveSuccessModel
        show={quoteSuccessShow}
        createMsg={quoteCreateMsg}
        setShow={setQuoteSuccessShow}
        SuccessDoneClick={SuccessDoneClick}
      />
      <ErrorMessage
        Show={errorShow?.show}
        errorMessage={errorShow?.errorMessage}
        ErrorDoneClick={ErrorDoneClick}
      />
    </>
  );
};
